import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import UtmModal from "../../Components/Modals/UtmLinks/UtmLinks";
import { useUtm } from "./useHook";
import { FiPlus } from "react-icons/fi";

function UtmLinks() {
  const { getUtmLinks, addUtm, updateUtmStatus } = useUtm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [utmLinks, setUtmLinks] = useState([]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const fetchUtmLinks = async () => {
    await getUtmLinks(setUtmLinks);
  };

  useEffect(() => {
    fetchUtmLinks();
  }, []);

  const handleToggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      const response = await updateUtmStatus(id, newStatus);
      if (response) {
        setUtmLinks((prev) =>
          prev.map((utm) =>
            utm.id === id ? { ...utm, status: newStatus } : utm,
          ),
        );

        Swal.fire({
          icon: "success",
          title: "Status Updated",
          text: "The UTM link status has been successfully updated!",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to Update Status",
        text: "There was an error updating the UTM link status. Please try again.",
        confirmButtonText: "OK",
      });
      console.error("Failed to update UTM link status:", error);
    }
  };

  const handleAddUtmLink = async (newUtm) => {
    try {
      const response = await addUtm(newUtm);
      if (response) {
        Swal.fire({
          icon: "success",
          title: "UTM Link Added",
          text: "Your UTM link has been successfully added!",
          confirmButtonText: "OK",
        });
        await fetchUtmLinks(); // Refresh the table by fetching the data again
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to Add UTM Link",
        text: "An error occurred while adding the UTM link. Please try again.",
        confirmButtonText: "OK",
      });
      console.error("Failed to add UTM link:", error);
    }
    closeModal();
  };

  return (
    <div>
      <div className="flex flex-wrap gap-4 justify-between items-center">
        <h2 className="text-2xl font-bold">Manage UTM</h2>

        <button onClick={openModal} className="btn btn-primary h-[44px]">
          <FiPlus className="text-white" />
          Add UTM Link
        </button>
      </div>

      <div className="bg-white w-full rounded-lg pagination-shadow my-5">
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto bg-white rounded-lg  overflow-hidden">
            <thead>
              <tr className="brand-gradient text-white">
                <th className="table-th">Sr. No</th>
                <th className="table-th">Base Url</th>
                <th className="table-th">Source</th>
                <th className="table-th">Medium</th>
                <th className="table-th">Campaign</th>
                <th className="table-th">Status</th>
              </tr>
            </thead>
            <tbody>
              {utmLinks.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center py-6 text-gray-500">
                    No data found
                  </td>
                </tr>
              ) : (
                utmLinks.map((utm, index) => (
                  <tr
                    key={utm.id}
                    className={`${
                      index % 2 === 0 ? "bg-gray-50" : "bg-gray-100"
                    } hover:bg-gray-200 transition-colors duration-300`}
                  >
                    <td className="table-td">{index + 1}</td>
                    <td className="table-td">{utm.baseUrl}</td>
                    <td className="table-td">{utm.source}</td>
                    <td className="table-td">{utm.medium}</td>
                    <td className="table-td">{utm.campaign}</td>
                    <td className="table-td">
                      <div
                        className={`status-toggle ${utm.status ? "active" : ""}`}
                        onClick={() => handleToggleStatus(utm.id, utm.status)}
                      >
                        <div className="status-toggle-handle"></div>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <UtmModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onSubmit={handleAddUtmLink}
      />
    </div>
  );
}

export default UtmLinks;
